import { render, staticRenderFns } from "./specialRewardDetail.vue?vue&type=template&id=afcba7ae&"
import script from "./specialRewardDetail.vue?vue&type=script&lang=js&"
export * from "./specialRewardDetail.vue?vue&type=script&lang=js&"
import style0 from "./specialRewardDetail.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports